import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Button, Stack, CircularProgress } from '@mui/material';
import {
  ANDROID_APP_URL,
  IOS_APP_URL,
  detectMobilePlatform,
  getStoreUrlForPlatform,
} from '../config/appStores';

/**
 * Public smart link: phones go to the matching store; desktop shows both options.
 * QR codes on /download-app should point here.
 */
const GetAppRedirect = () => {
  const [platform, setPlatform] = useState(null);

  useEffect(() => {
    const detected = detectMobilePlatform();
    setPlatform(detected);
    const storeUrl = getStoreUrlForPlatform(detected);
    if (storeUrl) {
      window.location.replace(storeUrl);
    }
  }, []);

  if (platform === 'ios' || platform === 'android') {
    const storeUrl = getStoreUrlForPlatform(platform);
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
          background: 'linear-gradient(165deg, #fff8f0 0%, #ffffff 45%, #fff1e6 100%)',
        }}
      >
        <Stack spacing={2} alignItems="center" sx={{ textAlign: 'center', maxWidth: 420 }}>
          <CircularProgress size={36} sx={{ color: '#FF7700' }} />
          <Typography sx={{ fontWeight: 700, color: '#1a1a1a' }}>
            Opening the {platform === 'ios' ? 'App Store' : 'Play Store'}…
          </Typography>
          <Button
            href={storeUrl}
            variant="contained"
            sx={{
              bgcolor: '#FF7700',
              textTransform: 'none',
              fontWeight: 700,
              '&:hover': { bgcolor: '#e56a00' },
            }}
          >
            Tap if nothing happens
          </Button>
        </Stack>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        background: 'linear-gradient(165deg, #fff8f0 0%, #ffffff 45%, #fff1e6 100%)',
      }}
    >
      <Stack spacing={2.5} alignItems="center" sx={{ textAlign: 'center', maxWidth: 440 }}>
        <Typography variant="h5" sx={{ fontWeight: 800, color: '#1a1a1a' }}>
          Get TabTrips Extranet
        </Typography>
        <Typography sx={{ color: '#555', lineHeight: 1.5 }}>
          Open this link on your phone, or choose your store below.
        </Typography>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ width: '100%' }}>
          <Button
            fullWidth
            href={ANDROID_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            sx={{
              bgcolor: '#FF7700',
              textTransform: 'none',
              fontWeight: 700,
              py: 1.25,
              '&:hover': { bgcolor: '#e56a00' },
            }}
          >
            Google Play
          </Button>
          <Button
            fullWidth
            href={IOS_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            variant="outlined"
            sx={{
              borderColor: '#FF7700',
              color: '#FF7700',
              textTransform: 'none',
              fontWeight: 700,
              py: 1.25,
              '&:hover': { borderColor: '#e56a00', bgcolor: 'rgba(255,119,0,0.06)' },
            }}
          >
            App Store
          </Button>
        </Stack>
        <Button
          component={RouterLink}
          to="/download-app"
          sx={{ textTransform: 'none', color: '#666', fontWeight: 600 }}
        >
          View download page
        </Button>
      </Stack>
    </Box>
  );
};

export default GetAppRedirect;
